<template>
  <div v-if="visible" class="position-absolute license-warning">
    <div class="content">
      <div class="left-box">
        <div style="margin-left: 11px">
          <div class="font-24 font-weight" style="color: #fa5151; margin-top: 163px"
            >证照过期预警</div
          >
          <div class="flex flex-col flex-center color-999 font-12 margin-top-5 margin-bottom-15">
            <span>数据更新于</span>
            <span>{{ popupData.time }}</span>
          </div>
          <div
            class="expire_box margin-bottom-30 flex flex-align-center pointer"
            :class="index === 1 ? 'expire_bg' : ''"
            @click="handleSelected(1)"
          >
            <img
              style="width: 26px; height: 26px"
              class="margin-x-10"
              :src="index === 1 ? expireActive : expireNormal"
            />
            <div class="flex flex-col">
              <span
                class="font-light margin-bottom-5"
                :style="index === 1 ? 'color: #fa5151' : 'color: #999'"
                >证照已过期</span
              >
              <span class="color-999 font-12 font-light">{{ detailData.expiredCount }}人</span>
            </div>
          </div>
          <div
            class="soon_box flex flex-align-center pointer"
            :class="index === 2 ? 'soon_bg' : ''"
            @click="handleSelected(2)"
          >
            <img
              style="width: 26px; height: 26px"
              class="margin-x-10"
              :src="index === 2 ? soonActive : soonNormal"
            />
            <div class="flex flex-col">
              <span
                class="font-light margin-bottom-5"
                :style="index === 2 ? 'color: #ff8157' : 'color: #666'"
                >证照即将过期</span
              >
              <span class="color-666 font-12 font-light"
                >{{ detailData.aboutToExpireCount }}人</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="right-box color-bg-fff position-relative" v-loading="loading">
        <div class="flex flex-between">
          <div class="font-14 color-666">
            请及时更新以下司机的证照信息，证照过期<span style="color: #fa5151">前3天</span
            >系统将自动封禁，封禁后无法使用
          </div>
          <i class="el-icon-close font-24 pointer" @click="handleClose"></i>
        </div>
        <div class="margin-top-20" style="height: calc(100% - 100px)">
          <div v-for="item in list" :key="item.driverId" class="padding-y-10 item">
            <div class="flex flex-align-center margin-bottom-8">
              <span
                class="font-weight pointer"
                style="color: #07c160"
                @click="jumpDetail(item, 'driver')"
                >{{ item.name }}</span
              >
              <div class="margin-x-10 line"></div>
              <span
                class="font-weight pointer"
                style="color: #07c160"
                @click="jumpDetail(item, 'car')"
                >{{ item.plateNumber }}</span
              >
            </div>
            <span class="font-14 font-light color-666">{{ item.content }}</span>
          </div>
        </div>
        <div class="text-center position-absolute color-fff btn-box color-bg-fff">
          <el-button class="btn margin-top-20" @click="seeMore">查看更多</el-button>
        </div>
      </div>
    </div>

    <DriverDetail ref="driver" />
    <VehicleDetail ref="car" />
  </div>
</template>

<script >
import { ref, computed, watch } from '@vue/composition-api';
import expireNormal from '@/static/icon_expire_normal.png';
import expireActive from '@/static/icon_expire.png';
import soonNormal from '@/static/icon_soon_normal.png';
import soonActive from '@/static/icon_soon.png';
import { licenseRemind } from '@/api';
import router from '@/router/router';
import DriverDetail from '@/views/driver/components/driver-detail.vue';
import VehicleDetail from '@/views/vehicle/components/vehicle-detail.vue';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const visible = ref(false);
  const index = ref(1);
  const detailData = ref({});
  const driver = ref();
  const car = ref();
  const loading = ref(false);
  const popupData = ref({});
  const list = computed(() => {
    const {
      aboutToExpireInfo = [],
      expiredInfo = []
    } = detailData.value;
    if (index.value === 1) return expiredInfo;
    return aboutToExpireInfo;
  });
  watch(visible, newVal => {
    if (!newVal) return;
    const app = document.getElementById('app');
    app.style.overflow = 'auto';
  });
  const init = data => {
    visible.value = true;
    popupData.value = data;
    getDetail(data.link);
  };
  const handleClose = () => {
    emit('close');
    visible.value = false;
  };
  const handleSelected = i => {
    index.value = i;
  };
  const getDetail = async link => {
    try {
      loading.value = true;
      const {
        code,
        data
      } = await licenseRemind({
        uuid: link
      });
      if (code) return;
      detailData.value = JSON.parse(data);
    } catch (error) {} finally {
      loading.value = false;
    }
  };
  const seeMore = () => {
    router.push({
      path: '/driver/driver-manage'
    });
    visible.value = false;
  };
  const jumpDetail = (item, type) => {
    if (type === 'driver') {
      driver.value.init({
        id: item.driverId
      });
      return;
    }
    car.value.init(item.carId);
  };
  return Object.assign({
    expireNormal,
    expireActive,
    soonNormal,
    soonActive,
    visible,
    index,
    detailData,
    driver,
    car,
    loading,
    popupData,
    list,
    handleClose,
    handleSelected,
    seeMore,
    jumpDetail
  }, {
    init
  });
};
__sfc_main.components = Object.assign({
  DriverDetail,
  VehicleDetail
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .license-warning {
    margin: auto;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    min-height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
  }
  .content {
    width: 890px;
    height: 545px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -445px;
    margin-top: -222.5px;
    border-radius: 10px;
  }
  .left-box {
    position: absolute;
    bottom: 0;
    width: 167px;
    height: 582px;
    background: url('../../static/icon_license_expire.png');
    background-size: 167px 582px;
    .expire_box {
      width: 156px;
      height: 84px;
      background: #f4f4f4;
      border-radius: 10px 0px 0px 10px;
    }
    .expire_bg {
      background: url('../../static/icon_expire_bg.png');
      background-size: 156px 84px;
    }
    .soon_box {
      width: 156px;
      height: 84px;
      background: #f4f4f4;
      border-radius: 10px 0px 0px 10px;
    }
    .soon_bg {
      background: url('../../static/icon_soon_bg.png');
      background-size: 156px 84px;
    }
  }
  .right-box {
    width: 723px;
    height: 100%;
    margin-left: 167px;
    border-radius: 0 10px 10px 0;
    padding: 25px 20px 10px 35px;
    box-sizing: border-box;
  }
  .line {
    border-left: 1px solid #d9d9d9;
    height: 12px;
  }
  .item {
    border-bottom: 1px solid #f3f3f3;
  }
  .btn-box {
    width: calc(100% - 45px);
    height: 77px;
    bottom: 0;
  }
  .btn {
    color: #fff;
    background: #07c160;
    width: 296px;
    height: 46px;
    border: none;
  }
</style>
